import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";

export const bigcommerceRoutes: PermissionedRouteObject[] = [
  {
    path: "auth",
    async lazy() {
      const { BigcommerceCallback } = await import("./callback");
      return { Component: BigcommerceCallback };
    },
  },
];
